import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export async function GetClientDocumentData(clientInfo, currentUserId) {
	console.log('Get Client Document Data');

	var jsonData = { clientInfo: clientInfo };
	jsonData['thisUserId'] = currentUserId;
	jsonData['projectCode'] = PROJECT_CODE.projectCode;
	//jsonData['authToken'] = authToken;

	var getClientDocumentInfo = await firebase
		.functions()
		.httpsCallable('GetClientDocumentInfo');

	console.log('GetClientDocumentData jsonData', jsonData);

	var clientExpanded;
	await getClientDocumentInfo(jsonData).then((result) => {
		console.log(
			'GetClientDocumentData results getClientDocumentInfo: ',
			result
		);

		clientExpanded = result;
		clientExpanded['originalClientEmail'] = clientInfo.clientemail;
	});
	console.log('ORIGINAL CLIENT INFO ' + clientInfo.clientemail);
	return clientExpanded;
}

export async function GetClientAPSFiles(clientInfo, currentUserId, authToken) {
	console.log('Get Client APS Files');

	var jsonData = { clientInfo: clientInfo };
	jsonData['thisUserId'] = currentUserId;
	jsonData['projectCode'] = PROJECT_CODE.projectCode;
	jsonData['authToken'] = authToken;

	var getClientDocumentInfo = await firebase
		.functions()
		.httpsCallable('GetClientLatestAPSFiles');

	//https://us-central1-planxr-demo-centre.cloudfunctions.net/GetClientLatestAPSFiles

	var clientFiles;
	await getClientDocumentInfo(jsonData).then((result) => {
		console.log('results: ' + JSON.stringify(result));

		clientFiles = result;
		clientFiles['originalClientEmail'] = clientInfo.clientemail;
	});

	return clientFiles;
}

export async function GetClientCondoFiles(
	clientInfo,
	currentUserId,
	authToken
) {
	console.log('Get Client Condo Doc Files');

	var jsonData = { clientInfo: clientInfo };
	jsonData['thisUserId'] = currentUserId;
	jsonData['projectCode'] = PROJECT_CODE.projectCode;
	jsonData['authToken'] = authToken;

	var getClientDocumentInfo = await firebase
		.functions()
		.httpsCallable('GetClientLatestCondoDocFiles');

	var clientFiles;
	await getClientDocumentInfo(jsonData).then((result) => {
		console.log('results: ' + JSON.stringify(result));

		clientFiles = result;
		clientFiles['originalClientEmail'] = clientInfo.clientemail;
	});

	return clientFiles;
}

export async function GetClientExtraFilesBySubject(
	clientInfo,
	currentUserId,
	subject,
	authToken
) {
	console.log('Get Extra Doc Files');

	var jsonData = { clientInfo: clientInfo };
	jsonData['thisUserId'] = currentUserId;
	jsonData['projectCode'] = PROJECT_CODE.projectCode;
	jsonData['subject'] = subject;
	jsonData['authToken'] = authToken;

	var getClientDocumentInfo = await firebase
		.functions()
		.httpsCallable('GetClientFilesBySubject');

	var clientFiles;
	await getClientDocumentInfo(jsonData).then((result) => {
		console.log('extra results: ' + JSON.stringify(result));

		clientFiles = result;
		clientFiles['originalClientEmail'] = clientInfo.clientemail;
	});

	return clientFiles;
}
